/**
 * https://stackoverflow.com/questions/3518504/regular-expression-for-matching-latitude-longitude-coordinates#comment87491242_18690202
 */

export default function parseLatLng(input) {
  const reg = /(^[-+]?(?:[1-8]?\d(?:\.\d+)?|90(?:\.0+)?)),\s*([-+]?(?:180(?:\.0+)?|(?:(?:1[0-7]\d)|(?:[1-9]?\d))(?:\.\d+)?))$/;
  const match = reg.exec(input);

  if (match) {
    return {
      latitude: parseFloat(match['1']),
      longitude: parseFloat(match['2']),
    };
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/utils/geoLocation.js